export default __webpack_public_path__ + "static/travel-transition-7ea65a5a84abe3481f67868406fa7283.gif";